<template>
  <div v-if="!checkMobile" class="popup-top-layer">
    <div class="popup-background-layer popup">
      <div class="popup-container">
        <div class="left-container">
          <b-img :src="imageDesktop" alt=""></b-img>
        </div>
        <div class="right-container">
          <div class="top-section-container">
            <div class="heading-desktop">
              <!--                  <b-img :src="headingImg" alt=""></b-img>-->
              <div class="heading-text">
                <h2>WELCOME TO ELITEFIT.AI</h2>
              </div>
            </div>
            <div class="subtitle-text">
              <p class="mb-0">Looks like you are a new user!</p>
              <p>Try a demo workout to learn how we work.</p>
            </div>
            <b-button class="try-now-button"
                      @click="tryNow"
            >TRY DEMO</b-button>
          </div>
          <b-button variant="link" class="cancel-button"
                    @click="hideModal"
          >Cancel</b-button>
          <b-form-checkbox size="sm" v-model="dontShowAgain" class="do-not-remind">Do not remind me again</b-form-checkbox>
        </div>
      </div>
    </div>
    <div class="popup-background-layer background"></div>
  </div>

  <div v-else class="popup-top-layer popup-mobile-dim">
    <div class="popup-background-layer popup">
      <div class="popup-container popup-container-mobile">
        <b-img :src="imageMobile" alt=""></b-img>
        <div class="bottom-container">
          <div class="top-section-container">
            <div class="heading-desktop">
              <!--                  <b-img :src="headingImg" alt=""></b-img>-->
              <div class="heading-text">
                <h2>WELCOME TO ELITEFIT.AI</h2>
              </div>
            </div>
            <div class="subtitle-text">
              <p class="mb-0">Looks like you are a new user!</p>
              <p>Try a demo workout to learn how we work.</p>
            </div>
            <b-button class="try-now-button"
                      @click="tryNow"
            >TRY DEMO</b-button>
          </div>
          <b-button variant="link" class="cancel-button"
                    @click="hideModal"
          >Cancel</b-button>
          <b-form-checkbox size="sm" v-model="dontShowAgain" class="do-not-remind">Do not remind me again</b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageDesktop from "@/module_b2b_users/assets/images/try_demo_background_desktop.png";
import ImageMobile from "@/module_b2b_users/assets/images/try_demo_background_mobile.png";
import {isMobile} from "@/utils/genericFunctions";

export default {
  name: "TryDemoPopup",
  data() {
    return {
      dontShowAgain: false,
      imageDesktop: ImageDesktop,
      imageMobile: ImageMobile,
    }
  },
  computed: {
    checkMobile() { return isMobile(); },
  },
  methods: {
    hideModal() {
      this.$root.$emit('bv::hide::modal', 'try-tutorial-popup-modal');
      localStorage.setItem('tryTutorialPopup', 'false');
      if (this.dontShowAgain) this.$store.dispatch("disableTutorialPopup");
    },
    tryNow() {
      this.hideModal();
      this.$router.push('/workoutIntro');
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-top-layer {
  position: relative;
  width: 570px;
  height: 342px;
  margin: auto;
  border-radius: 15px;
  overflow: hidden;

  .popup-background-layer {
    &.background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #8DC63F;
    }
    &.popup {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }
  .popup-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;

    .left-container {
      height: 100%;

      img {
        max-height: 100%;
      }
    }
    .right-container {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 5px 16px 20px 16px;
      margin-top: 35px !important;

      .top-section-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        color: #000000;
        .heading-desktop {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin: 5px auto;

          img {
            max-width: 124px;
            max-height: 118px;
          }
          .heading-text {
            display: flex;
            flex-direction: column;
            h2 {
              padding-left: 0px;
              font-size: 25px;
              font-weight: 700;
              margin-bottom: 0 !important;
              line-height: 38px;
              letter-spacing: 0em;
              text-align: center;

            }
          }
        }
        .subtitle-text {
          p {
            font-size: 18px;
            font-weight: 400;
            line-height: 27px;
            letter-spacing: 0em;
            text-align: center;

          }
        }
      }

      .try-now-button, .try-now-button:hover {
        background: #FFFFFF;
        border-radius: 25px;
        width: 179px;
        max-width: 400px;
        font-weight: 700;
        font-size: 20px;
        line-height: 30px;
        color: #000000;
        display: inline-block;
        text-decoration: none;
        border: 1px solid #000000;
        box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.25);
      }
      .cancel-button {
        margin-top: 1em;
        background-color: inherit;
        border-radius: 25px;
        width: 100px;
        height: 39px;
        max-width: 400px;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
        display: inline-block;
        text-decoration: none;
        border-width: 0;
      }
      .cancel-button:hover {
        color: red;
      }
      .do-not-remind {
        color: #FFFFFF;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;

      }
    }
  }
}

// for mobile
.popup-mobile-dim {
  width: 330px;
  height: 500px;
  border-radius: 15px;
  overflow: hidden;
  .popup-container-mobile {
    flex-direction: column;

    img {
      max-width: 100%;
      max-height: 145px;
      margin: auto;
    }
  }

  .bottom-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    padding: 5px 21px 20px 16px;
    margin-top: 0px !important;

    .top-section-container {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      color: #000000;
      .heading-desktop {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 5px auto;

        img {
          max-width: 124px;
          max-height: 118px;
        }
        .heading-text {
          display: flex;
          flex-direction: column;
          h2 {
            padding-left: 0px;
            font-weight: 700;
            margin-bottom: 0 !important;
            font-size: 32px;
            line-height: 48px;
            letter-spacing: 0em;
            text-align: center;
          }
        }
      }
      .subtitle-text {
        p {
          font-size: 18px;
          font-weight: 400;
          line-height: 24px;
          text-align: center;

        }
      }
    }

    .try-now-button, .try-now-button:hover {
      background: #FFFFFF;
      border-radius: 25px;
      width: 179px;
      max-width: 400px;
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      color: #000000;
      display: inline-block;
      text-decoration: none;
      border: 1px solid #000000;
      box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.25);
    }
    .cancel-button {
      margin-top: 1em;
      background-color: inherit;
      border-radius: 25px;
      width: 100px;
      height: 39px;
      max-width: 400px;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #FFFFFF;
      display: inline-block;
      text-decoration: none;
      border-width: 0;
    }
    .cancel-button:hover {
      color: red;
    }
    .do-not-remind {
      color: #FFFFFF;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: center;

    }
  }
}

::v-deep .custom-control-label::before {
  border-color: #fff !important;
  background-color: transparent !important;
}
::v-deep .custom-control-label::after {
  color: #000000;
}

::v-deep .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  // black tick
  background-image: url("data:image/svg+xml, %3csvg xmlns='http://www.w3.org/2000/svg' width='2' height='2' viewBox='0 0 8 8'%3e%3cpath d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e") !important;
}

</style>
